<!-- IOS Location Tutorial Modal -->
<ng-template #iosTutorialModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">ERRO: Localização no iOS desativada!</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose.emit('Cross click');d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="main-text">
      Veja como ativar:
    </p>
    <div class="gallery-controls">
      @if (curStep > 1) {
        <button class="btn btn-sl btn-primary" (click)="prevStep()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>
      }
      &nbsp; <i>Passo {{curStep}} de {{nSteps}}</i> &nbsp;
      @if (curStep < nSteps) {
        <button class="btn btn-sl btn-primary" (click)="nextStep()">
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </button>
      }
    </div>
    <div class="gallery-image">
      <img [src]="imgPath" alt="passo-a-passo">
    </div>
    <div class="gallery-controls">
      @if (curStep > 1) {
        <button class="btn btn-sl btn-primary" (click)="prevStep()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>
      }
      &nbsp; <i>Passo {{curStep}} de {{nSteps}}</i> &nbsp;
      @if (curStep < nSteps) {
        <button class="btn btn-sl btn-primary" (click)="nextStep()">
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </button>
      }
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="send();c('Enviar click')">Entendi</button>
  </div>
</ng-template>